import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { ToggleTableColumn } from '../table.column';
import { TableToggleElement } from '../table.element';
import { TableElement } from '../table.element';

class ToggleElement implements TableToggleElement {
  element: TableElement;

  constructor(element: TableElement) {
    this.element = element;
  }

  activeState(): string {
    return this.element.getData().activeState;
  }
}

@Component({
  selector: 'app-table-widget-toggle',
  templateUrl: 'toggle.component.html',
  styleUrls: ['toggle.component.css']
})
export class ToggleComponent extends ButtonComponent implements OnInit {

  // tslint:disable-next-line: deprecation
  constructor(ngEl: ElementRef, renderer: Renderer2) {
    super(ngEl, renderer);
  }

  ngOnInit() {
  }

  public getContent() {
    return (this.tableColumn as ToggleTableColumn).activeCaption(new ToggleElement(this.tableElement));
  }

}
